// 9fbef606107a605d69c0edbcd8029e5d
import Styled, { css } from 'styled-components';

export default css`
  &.filter-color-main {
    display: grid;
    grid-template-columns: auto auto auto;
    .outline {
      border-radius: 30px;
      border: 2px solid #000;
    }
    .color-cta {
      border: 0;
      background-color: #fff;
    }
    .color-grid {
      display: flex;
      flex-direction: column;
      flex: 1;
      text-align: center;
    }
    .color-name {
      font-weight: 400;
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy3}px;
      line-height: 20px;
      text-transform: capitalize;
      text-align: center;
    }
    .svg-color {
      width: 36px;
      border-radius: 30px;
    }
    .selected-color {
      width: 38px;
    }
    .color-click {
      min-height: 0;
      padding: 0;
      border: 0;
      background-color: #fff;
      width: 58px;
    }
    .color-container {
      margin: 7px 0;
      text-align: center;
      flex: 1 1 0%;
    }
    .white-color {
      border: #c5c5c5 solid 1px;
    }
    @media (min-width: 1920px) {
      display: grid;
      grid-template-columns: auto auto auto auto;
    }
    @media (max-width: 1200px) {
      grid-template-columns: auto auto auto auto auto auto;
      .color-name {
        display: block;
      }
    }
    @media (max-width: 768px) {
      grid-template-columns: auto auto auto auto;
      .color-name {
        width: 58px;
      }
    }
  }
`;

export const ColorList = Styled.li`
    ${(props) =>
      props.loadingState
        ? `
      pointer-events: none;
    `
        : ''}
`;
